<template>
  <div class="assets-offline-map">
    <div class="leaflet-map" v-if="mapOnly">
      <b-loading :is-full-page="false" :active="loading"></b-loading>
      <leaflet-offline-map
        :id="mapId"
        :config="config"
        :offline-download.sync="mapConfig_.offlineDownload"
        @click-map="onClickMap"
        @click-custom-control="onClickCustomControl"
        @click-feature="onClickFeature"
        @move-end="onMoveEnd"
        @border-reached="onBorderReached"
        @draw-created="onDrawCreated"
        @locationfound="onLocationfound"
        ref="leafletOfflineMap"
      >
        <template #insideBottom>
          <!-- <assets-offline-map-list
            :map-height="config.height ? config.height : undefined"
            :assets="assets"
            :selected="selectedAsset"
            @select="onListSelect"
            v-show="mode === 'list'"
          /> -->
          <assets-offline-map-import
            :map-height="config.height ? config.height : undefined"
            v-if="mapMode === 'import'"
          />
        </template>
      </leaflet-offline-map>
    </div>
    <div class="columns is-gapless has-background-white" v-else>
      <div class="column is-3" v-if="canFilter">
        <assets-offline-map-filter
          :map-height="config.height ? config.height : undefined"
          :asset-types="assetTypes"
          :loading="fetchingAssetTypes"
          :filtering="filtering"
        />
      </div>
      <div class="column">
        <div class="leaflet-map">
          <!-- We're no longer using the spinner for asset collection progress -->
          <!-- (we just let the map render and assets will show up when ready) -->
          <b-loading :is-full-page="false" :active="loading"></b-loading>
          <leaflet-offline-map
            :id="mapId"
            :config="config"
            :offline-download.sync="mapConfig_.offlineDownload"
            @click-map="onClickMap"
            @click-custom-control="onClickCustomControl"
            @click-feature="onClickFeature"
            @move-end="onMoveEnd"
            @border-reached="onBorderReached"
            @draw-created="onDrawCreated"
            @draw-start="onDrawStart"
            @draw-cancel="onDrawCancel"
            @locationfound="onLocationfound"
            ref="leafletOfflineMap"
          >
            <template #insideBottom>
              <!-- <assets-offline-map-list
                :map-height="config.height ? config.height : undefined"
                :assets="assets"
                :selected="selectedAsset"
                @select="onListSelect"
                v-show="mode === 'list'"
              /> -->
              <assets-offline-map-import
                :map-height="config.height ? config.height : undefined"
                v-if="mapMode === 'import'"
              />
            </template>
          </leaflet-offline-map>
        </div>
        <!-- <div class="card">
          <header class="card-header has-background-dark">
            <p class="card-header-title has-text-light">{{ title }}</p>
            <div class="buttons">
              <b-button
                size="is-small"
                :type="`${mode === 'map' ? 'is-link' : ''}`"
                @click="mode = 'map'"
              >MAP</b-button>
              <b-button
                size="is-small"
                :type="`${mode === 'list' ? 'is-link' : ''}`"
                :disabled="drawing"
                @click="mode = 'list'"
              >LIST</b-button>
              <b-button
                size="is-small"
                :type="`${drawing ? 'is-info' : ''}`"
                :disabled="mode === 'list' || creating"
                @click="toggleCreate"
                v-if="canCreate"
              >CREATE</b-button>
              <b-button
                size="is-small"
                :type="`${mode === 'import' ? 'is-link' : ''}`"
                @click="mode = 'import'"
                v-if="canImport"
              >IMPORT</b-button>
              <b-button size="is-small" v-if="canExport">EXPORT</b-button>
            </div>
          </header>
          <div class="card-content">
            <div class="leaflet-map">
              <b-loading :is-full-page="false" :active="loading"></b-loading>
              <leaflet-offline-map
                :id="mapId"
                :config="config"
                :offline-download.sync="mapConfig_.offlineDownload"
                @click-custom-control="onClickCustomControl"
                @click-feature="onClickFeature"
                @move-end="onMoveEnd"
                @border-reached="onBorderReached"
                @draw-created="onDrawCreated"
                ref="leafletOfflineMap"
              >
                <template #insideBottom>
                  <assets-offline-map-list
                    :map-height="(config.height ? config.height : undefined)"
                    :assets="assets"
                    :selected="selectedAsset"
                    @select="onListSelect"
                    v-show="mode === 'list'"
                  />
                  <assets-offline-map-import
                    :map-height="(config.height ? config.height : undefined)"
                    v-if="mode === 'import'"
                  />
                </template>
              </leaflet-offline-map>
            </div>
          </div>
        </div> -->
      </div>
      <!-- We need a better way to hide/toggle this column in certain modes -->
      <div v-if="mapMode != 'import'" class="column is-3">
        <assets-offline-map-form
          :contract="contract"
          :order-type-code="orderTypeCode"
          :map-height="config.height ? config.height : undefined"
          :asset-types="assetTypes"
          :loading="creating"
          :geometry-type="createdAsset ? createdAsset.geometryType : undefined"
          :coordinates="createdAsset ? createdAsset.assetNodes[0] : undefined"
          @create="create"
          @input-coordinates="onFormInputCoords"
          v-if="mode_ === 'create'"
        />
        <assets-offline-map-detail
          :map-height="config.height ? config.height : undefined"
          :asset="selectedAsset"
          :modifiable="modifiable"
          @archive="onDetailArchive"
          @close="onDetailClose"
          v-if="mode_ === 'detail'"
        >
          <template #headerButtons="{ close }">
            <slot name="detailHeaderButtons" :close="close" />
          </template>
        </assets-offline-map-detail>
        <assets-offline-map-summary
          :contract="contract"
          :order-type-code="orderTypeCode"
          :map-height="config.height ? config.height : undefined"
          :colors="styleColors"
          @color-changed="onSummaryColorChanged"
          v-show="mode_ === 'summary'"
          v-if="canViewSummary"
          ref="summary"
        >
          <template #headerButtons>
            <b-button size="is-small" @click="mode_ = 'list'">LIST</b-button>
            <b-button
              size="is-small"
              :type="`${mapMode === 'import' ? 'is-info' : ''}`"
              @click="mapMode = mapMode === 'import' ? 'map' : 'import'"
              v-if="canImport"
              >IMPORT</b-button
            >
          </template>
          <template #contentTop>
            <div style="padding: 10px">
              <base-select
                v-model="contract"
                :service="$options.contractService"
                fetch-func="all"
                :fetch-params="{
                  includes: 'contractor',
                }"
                default-option-label="Select Contract"
                preselect-on-one
                hidden-on-one
              >
                <template #customLabel="{ option }">
                  {{ `${option.contractor.name} - ${option.name}` }}
                </template>
              </base-select>
              <base-select
                v-model="orderTypeCode"
                :service="$options.codeService"
                fetch-func="all"
                :fetch-params="{
                  type: 'orderType',
                  contract_id: contract || undefined,
                  firm_id: contract ? undefined : $store.state.Auth.user.firmId,
                }"
                :fetch-on-init="false"
                default-option-label="Select Order Type"
                ref="selectOrderTypeSummary"
              ></base-select>
            </div>
          </template>
        </assets-offline-map-summary>
        <assets-offline-map-list
          :contract="contract"
          :order-type-code="orderTypeCode"
          :config="config"
          :map-height="config.height ? config.height : undefined"
          :asset-types="assetTypes"
          :selected="selectedAsset"
          @select="onListSelect"
          @assign="onListAssign"
          @unassign="onListAssign"
          v-show="mode_ === 'list'"
          v-if="!localList"
          ref="list"
        >
          <template #headerButtons>
            <b-button
              size="is-small"
              @click="mode_ = 'summary'"
              v-if="canViewSummary"
              >SUMMARY</b-button
            >
            <b-button
              size="is-small"
              :type="`${mapMode === 'import' ? 'is-info' : ''}`"
              @click="mapMode = mapMode === 'import' ? 'map' : 'import'"
              v-if="canImport"
              >IMPORT</b-button
            >
          </template>
          <template #contentTop>
            <div style="padding: 10px">
              <base-select
                v-model="contract"
                :service="$options.contractService"
                fetch-func="all"
                :fetch-params="{
                  includes: 'contractor',
                }"
                default-option-label="Select Contract"
                preselect-on-one
                hidden-on-one
              >
                <template #customLabel="{ option }">
                  {{ `${option.contractor.name} - ${option.name}` }}
                </template>
              </base-select>
              <base-select
                v-model="orderTypeCode"
                :service="$options.codeService"
                fetch-func="all"
                :fetch-params="{
                  type: 'orderType',
                  contract_id: contract || undefined,
                  firm_id: contract ? undefined : $store.state.Auth.user.firmId,
                }"
                :fetch-on-init="false"
                default-option-label="Select Order Type"
                ref="selectOrderTypeList"
              ></base-select>
              <hr style="margin: 10px 0" />
              <location-autocomplete
                :with-site-assets="withSiteAssets"
                :config="{ autofocus: true }"
                @location="onSelectLocation"
              />
            </div>
          </template>
        </assets-offline-map-list>
        <assets-offline-map-local-list
          :map-height="config.height ? config.height : undefined"
          :assets="assets"
          :selected="selectedAsset"
          @select="onListSelect"
          @filter="onLocalListFilter"
          @reset="onLocalListReset"
          v-show="mode_ === 'list'"
          v-if="localList"
        >
          <template #contentTop>
            <slot name="localListContentTop" />
            <location-autocomplete
              :with-site-assets="withSiteAssets"
              :config="{ autofocus: true }"
               style="margin-bottom: 10px"
              @location="onSelectLocation"
            />
          </template>
        </assets-offline-map-local-list>
        <slot name="custom" :mode="mode_" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { Icon } from "leaflet";
import LeafletOfflineMap from "@/components/LeafletOfflineMap";
import AssetsOfflineMapList from "./AssetsOfflineMapList";
import AssetsOfflineMapLocalList from "./AssetsOfflineMapLocalList";
import AssetsOfflineMapDetail from "./AssetsOfflineMapDetail";
import AssetsOfflineMapFilter from "./AssetsOfflineMapFilter";
import AssetsOfflineMapForm from "./AssetsOfflineMapForm";
import AssetsOfflineMapSummary from "./AssetsOfflineMapSummary";
import AssetsOfflineMapImport from "./AssetsOfflineMapImport";
import BaseSelect from "@/components/partials/BaseSelect";
import LocationAutocomplete from "@/components/Order/LocationAutocomplete";
import { AssetService } from "@/services/asset.service";
import { CodeService } from "@/services/code.service";
import { ContractService } from "@/services/contract.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {
  codeService: CodeService,
  contractService: ContractService,
  props: {
    title: {
      type: String,
      default: "SCHEDULE OF ASSETS"
    },
    mode: {
      type: String,
      validator: value =>
        ["summary", "list", "detail", "create", "custom"].indexOf(value) !== -1,
      default: "summary"
    },
    mapId: {
      type: String
    },
    mapConfig: {
      type: Object,
      default: () => {}
    },
    selected: {
      type: Object
    },
    modifiable: {
      type: Boolean,
      default: true
    },
    canFilter: {
      type: Boolean,
      default: false
    },
    canViewSummary: {
      type: Boolean,
      default: true
    },
    canCreate: {
      type: Boolean,
      default: true
    },
    canImport: {
      type: Boolean,
      default: false
    },
    canExport: {
      type: Boolean,
      default: false
    },
    fetchOn: {
      type: String,
      validator: value => ["pan", "border"].indexOf(value) !== -1
    },
    mapOnly: {
      type: Boolean,
      default: false
    },
    // If set to true, list will use assets fetched by the map
    localList: {
      type: Boolean,
      default: false
    },
    fetchParams: {
      type: Object,
      default: () => ({})
    },
    customFilterAssets: {
      type: Function,
      required: false
    },
    assetCodeChainIds: {
      type: Array,
      required: false
    },
    contractId: {
      type: [String, Number],
    },
    // contractIds: {
    //   type: Array,
    //   default: () => ([]),
    // },
    orderTypeCodeId: {
      type: [String, Number],
    },
    // includeOrderTypeCodeId: {
    //   type: [String, Number],
    // },
    withUnassignedOrderTypeCodes: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LeafletOfflineMap,
    AssetsOfflineMapList,
    AssetsOfflineMapLocalList,
    AssetsOfflineMapDetail,
    AssetsOfflineMapFilter,
    AssetsOfflineMapForm,
    AssetsOfflineMapSummary,
    AssetsOfflineMapImport,
    BaseSelect,
    LocationAutocomplete,
  },
  filters: {
    ucfirst(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  },
  data: () => ({
    assetService: AssetService,
    codeService: CodeService,
    mapConfig_: {
      center: {
        lat: -36.848448,
        lng: 174.762191
      },
      zoom: 18,
      minZoom: 16,
      maxZoom: 19,
      offlineDownload: true,
      clickable: true,
      customControlIcon: "fa fa-fire"
    },
    mapCenter: null,
    mode_: "summary",
    prevMode: "summary",
    mapMode: "map",
    styles: {},
    styleColors: {},
    filters: {},
    assetTypes: [],
    assets: [],
    selectedAsset: null,
    createdAsset: null,
    // Vector grid index where the created asset is stored
    createdIndex: null,
    // Vector grid index where the filtered assets are stored
    filteredIndex: null,
    cancelToken: null,
    cancelTokenSrc: null,
    // This will prevent onBorderReached from firing immediately on load because of small border (?)
    initialLoad: false,
    loading: false,
    drawing: false,
    creating: false,
    importing: false,
    fetchingAssetTypes: false,
    filtering: false,
    contract: null,
    orderTypeCode: null,
  }),
  computed: {
    config() {
      return {
        ...this.mapConfig_,
        ...this.mapConfig,
        hidden: this.mapMode !== "map",
        // hasDrawControl: this.drawing,
        hasCustomControl: !this.fetchOn
      };
    },
    assetsMap() {
      return this.$store.state.AssetsMap;
    },
    withSiteAssets() {
      return !!this.assetTypes.find(v => (v.code || "").toUpperCase() == 'SITE');
    },
  },
  created() {
    // Moved it to created because it causes the map to pan on mounted causing the asset fetch request to be cancelled
    this.setInitialMapCenter();
    this.cancelToken = axios.CancelToken;
  },
  async mounted() {
    this.contract = this.contractId;
    // this.orderTypeCode = this.orderTypeCodeId || this.includeOrderTypeCodeId;
    this.orderTypeCode = this.orderTypeCodeId || null;

    await this.fetchAssetTypes();

    this.setStyles();
    this.setStyleColors();

    this.$nextTick(async () => {
      // Load saved assets
      this.loadGeoJson(this.assetsMap.assets);

      if (!this.fetchOn || this.fetchOn === "border") {
        await this.fetch(true);
        this.initialLoad = true;
      }
      // Make sure initial assets are loaded before selecting the default selected asset
      if (this.selected) {
        this.selectFeature(this.selected.id);
      }
    });
  },
  destroyed() {
    if (this.cancelTokenSrc) {
      this.cancelTokenSrc.cancel();
    }
  },
  watch: {
    selectedAsset: {
      handler(selectedAsset) {
        if (selectedAsset) {
          // Not final. Still need to determine the center if the asset is a line/polygon.
          this.mapConfig_.center = {
            lat: selectedAsset.assetNodes[0].latitude,
            lng: selectedAsset.assetNodes[0].longitude
          };
          this.$nextTick(() => {
            this.changeMode("detail");
          });
        }
      }
    },
    mode: {
      handler(mode) {
        this.changeMode(mode);
      },
      immediate: true
    },
    mode_(mode) {
      // Map is broken (not fitted in container, wrong popup location, etc) when switching back from other modes
      if (mode === "map") {
        if (this.selectedAsset) {
          this.resetView();
          this.$nextTick(() => {
            this.$refs.leafletOfflineMap.resetActiveFeaturePopup();
          });
        } else {
          this.resetView(false);
        }
      }

      this.$emit("update:mode", mode);
    },
    mapCenter(center) {
      this.$emit("update:mapCenter", center);
    },
    contract(contract) {
      // Toggle draw control
      this.$set(this.mapConfig_, "hasDrawControl", !!contract);
      this.$set(this.mapConfig_, "hasDrawToggleControl", !!contract);
      // Clear assets on map (and on list/summary)
      // if (this.$refs.summary) {
      //   this.$refs.summary.clear();
      // }
      // if (this.$refs.list) {
      //   this.$refs.list.$refs.baseTable.data = [];
      // }
      this.$refs.leafletOfflineMap.removeVectorGridsToMap();
      this.$store.commit("AssetsMap/SET_ASSETS", []);
      // Fetch assets on map (and on list/summary)
      this.$nextTick(() => {
        if (this.$refs.summary) {
          this.$refs.summary.fetch();
        }
        if (this.$refs.list) {
          this.$refs.list.fetch();
        }
        this.fetchAssetTypes();
        this.fetch(true);

        // Fetch order type codes
        if (this.$refs.selectOrderTypeList) {
          this.$refs.selectOrderTypeList.fetchOptions();
        }
        if (this.$refs.selectOrderTypeSummary) {
          this.$refs.selectOrderTypeSummary.fetchOptions();
        }
      });
    },
    orderTypeCode() {
      this.$refs.leafletOfflineMap.removeVectorGridsToMap();
      this.$store.commit("AssetsMap/SET_ASSETS", []);
      // Fetch assets on map (and on list/summary)
      this.$nextTick(() => {
        if (this.$refs.summary) {
          this.$refs.summary.fetch();
        }
        if (this.$refs.list) {
          this.$refs.list.fetch();
        }
        this.fetchAssetTypes();
        this.fetch(true);
      });
    },
  },
  methods: {
    changeMode(mode) {
      this.prevMode = this.mode_ === mode ? this.prevMode : this.mode_;
      this.mode_ = mode;
    },
    resetView(config = true) {
      this.$refs.leafletOfflineMap.resetView(config);
    },
    loadGeoJson(assets, style = "default", merge = true) {
      assets = JSON.parse(JSON.stringify(assets));

      assets = (typeof this.customFilterAssets === 'function')
        ? this.customFilterAssets(assets, { assetCodes: this.assetTypes })
        : assets;

      if (merge) {
        this.assets = this.assets.concat(assets);
      }

      return this.$refs.leafletOfflineMap.loadGeoJson(
        this.transformGeoJson(assets),
        "ASSET_ID",
        this.styles[style],
        this.styles.active,
        this.geoJsonPopup
      );
    },
    transformGeoJson(assets) {
      const features = assets.map(asset => {
        let nodes = [];
        let coordinates = [];

        asset.assetNodes.forEach(node => {
          nodes.push([parseFloat(node.longitude), parseFloat(node.latitude)]);
        });

        switch (asset.geometryType) {
          case "Point":
            coordinates = nodes[0];
            break;

          case "LineString":
            coordinates = nodes;
            break;

          case "Polygon":
            coordinates.push(nodes);
            break;
        }

        let geometry = {
          type: asset.geometryType,
          coordinates: coordinates
        };

        // Custom assets
        if (asset.code) {
          switch (asset.code.name) {
            case "Catchpit":
              // Only modify catchpit assets with point type
              // if (geometry.type === "Point") {
              //   const padding = 0.00003;

              //   // Convert to square
              //   geometry = {
              //     type: "Polygon",
              //     coordinates: [
              //       [
              //         [
              //           nodes[0][0] - padding,
              //           nodes[0][1] - padding
              //         ],
              //         [
              //           nodes[0][0] + padding,
              //           nodes[0][1] - padding
              //         ],
              //         [
              //           nodes[0][0] + padding,
              //           nodes[0][1] + padding
              //         ],
              //         [
              //           nodes[0][0] - padding,
              //           nodes[0][1] + padding
              //         ],
              //         [
              //           nodes[0][0] - padding,
              //           nodes[0][1] - padding
              //         ]
              //       ]
              //     ]
              //   };
              // }
              break;
          }
        }

        return {
          type: "Feature",
          geometry: geometry,
          properties: {
            ...JSON.parse(asset.tags || "{}"),
            ASSET_ID: asset.id,
            ASSET_SAP_ID: asset.thirdPartyCode || null,
            ASSET_NAME: asset.assetName,
            ASSET_TYPE_CODE: asset.code ? asset.code.code : null,
            ASSET_TYPE_NAME: asset.code ? asset.code.name : null,
            ASSET_HOTSPOT: asset.hotspot || null,
            ASSET_GEOMETRY_TYPE: asset.geometryType
          }
        };
      });

      return {
        type: "FeatureCollection",
        features: features
      };
    },
    geoJsonPopup(properties) {
      const content = document.createElement("div");

      content.innerHTML = `
        <table class="table is-bordered is-narrow">
          <tr><th>ID</th><td>${properties.ASSET_SAP_ID || ""}</td></tr>
          <tr><th>TYPE</th><td>${properties.ASSET_TYPE_CODE ? `${properties.ASSET_TYPE_CODE} - ${properties.ASSET_TYPE_NAME}` : ""}</td></tr>
          <tr><th>NAME</th><td>${properties.ASSET_NAME ? `${properties.ASSET_NAME}` : ""}</td></tr>
        </table>
      `;

      return content;
    },
    // Select map assets externally
    selectFeature(id) {
      const asset = this.assetsMap.assets.find(asset => asset.id === id);

      if (asset) {
        const popup = {
          content: this.geoJsonPopup({
            ASSET_SAP_ID: asset.thirdPartyCode,
            ASSET_TYPE_CODE: asset.code ? asset.code.code : null,
            ASSET_TYPE_NAME: asset.code ? asset.code.name : null,
            ASSET_NAME: asset.assetName,
          }),
          latLng: {
            lat: asset.assetNodes[0].latitude,
            lng: asset.assetNodes[0].longitude
          }
        };

        this.$refs.leafletOfflineMap.clickFeature(
          id,
          this.styles.active,
          popup
        );
      }
    },
    unselectFeature() {
      if (this.selectedAsset) {
        this.$refs.leafletOfflineMap.clickFeature(this.selectedAsset.id);
      }
    },
    setStyles() {
      const icons = {
        CPIT: new Icon({
          iconUrl: require("@/assets/map/cpit.png"),
          iconSize: [13, 11],
          iconAnchor: [6.5, 5.5]
        }),
        CPIT_ACTIVE: new Icon({
          iconUrl: require("@/assets/map/cpit_active.png"),
          iconSize: [13, 11],
          iconAnchor: [6.5, 5.5]
        }),
        ILOL: new Icon({
          iconUrl: require("@/assets/map/ilol.png"),
          iconSize: [10, 10],
          iconAnchor: [7, 12]
        }),
        ILOL_ACTIVE: new Icon({
          iconUrl: require("@/assets/map/ilol_active.png"),
          iconSize: [10, 10],
          iconAnchor: [7, 12]
        }),
        MHCR: new Icon({
          iconUrl: require("@/assets/map/mhcr.png"),
          iconSize: [11, 11],
          iconAnchor: [5.5, 5.5]
        }),
        MHCR_ACTIVE: new Icon({
          iconUrl: require("@/assets/map/mhcr_active.png"),
          iconSize: [11, 11],
          iconAnchor: [5.5, 5.5]
        }),
        SOAK: new Icon({
          iconUrl: require("@/assets/map/soak.png"),
          iconSize: [14, 14],
          iconAnchor: [7, 14]
        }),
        SOAK_ACTIVE: new Icon({
          iconUrl: require("@/assets/map/soak_active.png"),
          iconSize: [14, 14],
          iconAnchor: [7, 14]
        }),
        WRTD: new Icon({
          iconUrl: require("@/assets/map/wrtd.png"),
          iconSize: [17, 15],
          iconAnchor: [8, 16]
        }),
        WRTD_ACTIVE: new Icon({
          iconUrl: require("@/assets/map/wrtd_active.png"),
          iconSize: [17, 15],
          iconAnchor: [8, 16]
        })
      };
      this.styles = {
        default: properties => {
          let style = {
            color: "#8ED274",
            fillColor: "#8ED274",
            weight: 4.5,
            radius: 4.5,
            fill: true,
            fillOpacity: 0.7,
            className: "asset"
          };

          const typeColor = this.styleColors[properties.ASSET_TYPE_CODE];

          if (typeColor) {
            style.color = typeColor;
            style.fillColor = typeColor;
          }

          if (Object.keys(icons).includes(properties.ASSET_TYPE_CODE)) {
            style.icon = icons[properties.ASSET_TYPE_CODE];
          }

          return style;
        },
        active: properties => {
          let style = {
            color: "#E97F8B",
            fillColor: "#E97F8B",
            weight: 4.5,
            radius: 4.5,
            fill: true,
            fillOpacity: 0.7
          };

          if (Object.keys(icons).includes(properties.ASSET_TYPE_CODE)) {
            style.icon = icons[`${properties.ASSET_TYPE_CODE}_ACTIVE`];
          }

          return style;
        },
        created: properties => {
          return {
            color: "#3273DC",
            fillColor: "#3273DC",
            weight: 2,
            radius: 3,
            fill: true,
            fillOpacity: 0.7
          };
        }
      };
    },
    setStyleColors() {
      this.assetTypes.forEach(type => {
        const colorAttribute = type.attributes.find(attribute => attribute.code === "asset_map_marker_color");

        if (colorAttribute && colorAttribute.value) {
          this.$set(this.styleColors, type.code, colorAttribute.value);
        }
      });
    },
    setInitialMapCenter() {
      let center = null;

      // Prioritize selected asset over config
      if (this.selected) {
        center = {
          lat: this.selected.assetNodes[0].latitude,
          lng: this.selected.assetNodes[0].longitude
        };
      } else if (this.mapConfig.center) {
        center = this.mapConfig.center;
      } else if (this.$store.state.Auth.user.default_x && this.$store.state.Auth.user.default_y) {
        center = {
          lat: this.$store.state.Auth.user.default_x,
          lng: this.$store.state.Auth.user.default_y,
        };
      }

      if (center) {
        // Prevent mapConfig's center property from overriding  mapConfig_'s center
        delete this.mapConfig.center;

        this.mapConfig_.center = center;
        this.setMapCenter(center);
      }
    },
    async fetch(load = false) {
      if ( ! this.contract) return;

      if (this.config.offlineDownload && navigator.onLine) {
        if (this.cancelTokenSrc) {
          this.cancelTokenSrc.cancel();
        }

        this.cancelTokenSrc = this.cancelToken.source();

        this.loading = load;

        const response = await this.assetService.all(
          {
            ...this.fetchParams,
            centerX: this.mapCenter.lng,
            centerY: this.mapCenter.lat,
            outerRad: this.assetsMap.maxRadius,
            per_page: this.assetsMap.maxAssets,
            contract_ids: [this.contract],
            // orderType_code_id: this.includeOrderTypeCodeId ? undefined : (this.orderTypeCode || undefined),
            // include_orderType_code_id: this.includeOrderTypeCodeId ? (this.orderTypeCode || undefined) : undefined,
            orderType_code_ids: this.orderTypeCode ? [this.orderTypeCode] : undefined,
            with_unassigned_orderType_codes: this.withUnassignedOrderTypeCodes ? 1 : undefined,
          },
          {
            cancelToken: this.cancelTokenSrc.token
          }
        );

        this.$store.commit(
          "AssetsMap/ADD_ASSETS",
          JsonDenormalizer.denormalize(response)
        );

        this.loadGeoJson(this.assetsMap.newAssets);

        // Notify max assets has been reached and not all assets are loaded in the map
        if (response.meta &&
          response.meta.pagination &&
          response.meta.pagination.total > response.meta.pagination.count
        ) {
          this.$buefy.toast.open({
            message: "Maximum assets on map, reduce proximity to see all.",
            type: "is-warning",
            position: "is-top-right"
          });
        }

        this.loading = false;
      }
    },
    async fetchAssetTypes() {
      if ( ! this.contract) return;

      this.fetchingAssetTypes = true;
      const asset_code_chain_ids = this.assetCodeChainIds ? this.assetCodeChainIds : [];

      this.assetTypes = await this.codeService
        .chained({
          type: "asset",
          ids: asset_code_chain_ids,
          contract_id: this.contract,
          includes: "attributes"
        })
        .then(response => JsonDenormalizer.denormalize(response));

      this.fetchingAssetTypes = false;
    },
    async create(form) {
      this.creating = true;

      try {
        const assetNodes = this.createdAsset
          ? this.createdAsset.assetNodes
          : undefined;
        const geometryType = this.createdAsset
          ? this.createdAsset.geometryType
          : undefined;

        const asset = await this.assetService
          .create({
            codeId: form.type,
            thirdPartyCode: form.thirdPartyCode,
            comment: form.description,
            geometryType,
            assetNodes,
            contract_ids: [this.contract],
            orderType_code_ids: this.orderTypeCode ? [this.orderTypeCode] : undefined,
          })
          .then(response => JsonDenormalizer.denormalize(response));

        this.$store.commit("AssetsMap/ADD_ASSETS", [asset]);
        this.loadGeoJson([asset]);

        this.$buefy.toast.open({
          message: "Asset has been created.",
          type: "is-info",
          position: "is-top-right"
        });

        // this.toggleCreate();
        this.$refs.leafletOfflineMap.toggleDrawing();

        // Fetch assets on list/summary
        if (this.$refs.summary) {
          this.$refs.summary.fetch();
        }
        if (this.$refs.list) {
          this.$refs.list.fetch();
        }

        this.$emit("asset-created", asset);
      } catch (err) {}

      this.creating = false;
    },
    // Check if current leaflet map center is not the same as the previous map center
    // To avoid duplicate asset fetch requests
    // Return true if the map center has changed
    setMapCenter(center) {
      if (
        !this.mapCenter ||
        (this.mapCenter.lat != center.lat && this.mapCenter.lng != center.lng)
      ) {
        this.mapCenter = center;

        return true;
      }

      return false;
    },
    toggleCreate() {
      this.drawing = !this.drawing;

      if (this.drawing) {
        this.$emit("draw-start");
      } else {
        this.removeCreated();
        this.$emit("draw-cancel");
      }
    },
    removeCreated() {
      if (this.createdIndex) {
        this.$refs.leafletOfflineMap.removeVectorGrid(this.createdIndex);
      }

      this.createdAsset = null;
      this.createdIndex = null;
    },
    updateSelected(id) {
      if (this.selectedAsset && this.selectedAsset.id === id) {
        this.selectedAsset = null;
        this.changeMode(this.prevMode);
      } else {
        this.selectedAsset = this.assets.find(asset => asset.id === id);
      }

      this.$emit("select", this.selectedAsset);
      this.$emit("update:select", this.selectedAsset);
    },
    onClickMap(event) {
      this.$emit("click-map", event);
    },
    // Update selected asset when selecting assets in map
    onClickFeature(event) {
      this.updateSelected(event);
    },
    // Custom control = Manual assets fetch control
    onClickCustomControl() {
      this.fetch(true);
    },
    // Fetch assets when center has changed and fetch mode is set to pan
    onMoveEnd(event) {
      if (
        this.setMapCenter(event.target.getCenter()) &&
        this.fetchOn === "pan"
      ) {
        this.fetch();
      }
    },
    // Fetch assets when fetch mode is set to border
    onBorderReached(event) {
      if (this.fetchOn === "border" && this.initialLoad) {
        this.setMapCenter(event);
        this.fetch();
      }
    },
    onDrawStart() {
      // this.drawing = true;
      this.changeMode("create");
      this.$emit("draw-start");
    },
    onDrawCancel() {
      this.removeCreated();
      // this.drawing = false;
      this.changeMode(this.prevMode);
      this.$emit("draw-cancel");
    },
    onDrawCreated(event) {
      this.removeCreated();

      this.createdAsset = null;

      switch (event.layerType) {
        case "marker":
          this.createdAsset = {};
          this.createdAsset.id = "created";
          this.createdAsset.geometryType = "Point";
          this.createdAsset.assetNodes = [event.layer.getLatLng()];
          break;

        case "polyline":
          this.createdAsset = {};
          this.createdAsset.id = "created";
          this.createdAsset.geometryType = "LineString";
          this.createdAsset.assetNodes = event.layer.getLatLngs();
          break;

        case "polygon":
          this.createdAsset = {};
          this.createdAsset.id = "created";
          this.createdAsset.geometryType = "Polygon";
          this.createdAsset.assetNodes = event.layer.getLatLngs()[0];
          break;
      }

      if (this.createdAsset) {
        this.createdAsset.assetNodes = this.createdAsset.assetNodes.map(
          node => {
            return {
              latitude: node.lat,
              longitude: node.lng
            };
          }
        );

        this.createdIndex = this.loadGeoJson(
          [this.createdAsset],
          "created",
          false
        );
      }
    },
    onLocationfound(event) {
      this.$emit("locationfound", event);
    },
    async onListSelect(asset) {
      if (this.config.clickable && asset) {
        const exist = this.assets.find(asset_ => asset_.id === asset.id);

        if (exist) {
          this.selectFeature(asset.id);
        } else {
          const center = {
            lat: asset.assetNodes[0].latitude,
            lng: asset.assetNodes[0].longitude
          };
          this.mapConfig_.center = center;
          this.setMapCenter(center);

          setTimeout(async () => {
            await this.fetch();
            this.selectFeature(asset.id);
          }, 800);
        }
      }
    },
    onListAssign() {
      this.$refs.leafletOfflineMap.removeVectorGridsToMap();
      this.$store.commit("AssetsMap/SET_ASSETS", []);
      // Fetch assets on map (and on list/summary)
      this.$nextTick(() => {
        if (this.$refs.summary) {
          this.$refs.summary.fetch();
        }
        if (this.$refs.list) {
          this.$refs.list.fetch();
        }
        this.fetchAssetTypes();
        this.fetch(true);
      });
    },
    // This will clear the current assets and display the filtered assets
    // The original assets are still stored in vuex's store
    // The original assets' vector grids will be removed from the map
    // For now, the only way to add the original assets' vector grids back to the map is by reseting the filter
    onLocalListFilter(assets) {
      this.$refs.leafletOfflineMap.removeVectorGridsToMap(
        this.filteredIndex ? [this.filteredIndex] : []
      );

      if (this.filteredIndex) {
        this.$refs.leafletOfflineMap.removeVectorGrid(this.filteredIndex);
      }

      // don't merge it the assets in vuex's store
      this.filteredIndex = this.loadGeoJson(assets, "default", false);
    },
    // This will permanently remove the filtered assets' vector grid
    // This will add the original assets' vector grids back to the map
    onLocalListReset() {
      if (this.filteredIndex) {
        this.$refs.leafletOfflineMap.removeVectorGrid(this.filteredIndex);
      }
      this.$refs.leafletOfflineMap.addVectorGridsToMap();
      this.filteredIndex = null;
    },
    onDetailArchive() {
      if (this.$refs.list) {
        this.$refs.list.fetch();
      }
    },
    onDetailClose(mode) {
      console.log(mode)
      if (this.config.clickable) {
        this.unselectFeature();
        this.changeMode(mode || this.prevMode);
      }
    },
    onSummaryColorChanged(payload) {
      this.$set(this.styleColors, payload.type, payload.color);

      const excludes = [];

      // Check if there's a vector grid for created assets
      if (this.createdIndex) {
        excludes.push(this.createdIndex);
      }

      // Reload vector grid styles
      this.$refs.leafletOfflineMap.restyleVectorGrids(
        this.styles.default,
        excludes
      );
    },
    onSelectLocation(location) {
      const center = {
        lat: location.latitude,
        lng: location.longitude
      };
      this.mapConfig_.center = center;
      this.setMapCenter(center);
      this.$nextTick(() => {
        this.fetch();
      });
    },
    onFormInputCoords(coords) {
      // From onDrawCreated()
      this.removeCreated();
      if (!coords) return;
      this.createdAsset = {};
      this.createdAsset.id = "created";
      this.createdAsset.geometryType = "Point";
      this.createdAsset.assetNodes = [
        {
          latitude: coords.latitude,
          longitude: coords.longitude,
        }
      ];
      this.createdIndex = this.loadGeoJson(
        [this.createdAsset],
        "created",
        false
      );
      // Set coords as map center
      const center = {
        lat: coords.latitude,
        lng: coords.longitude,
      };
      this.mapConfig_.center = center;
      this.setMapCenter(center);
    },
  }
};
</script>

<style lang="scss" scoped>
.leaflet-map {
  position: relative;

  .loading-overlay {
    z-index: 9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AssetsOfflineMap.vue